import React, { useEffect, useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InputMask from "react-input-mask";
import Key from "../../../clientVariables.json";
import {
  Tooltip,
  Avatar,
  Box,
  Grid,
  List,
  ListItemButton,
  Paper,
  useMediaQuery,
  useTheme,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Radio,
  Divider,
  TextField,
  FormControlLabel,
  Alert,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Chip,
  Checkbox,
  AlertTitle,
  LinearProgress,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { MdMoreVert } from "react-icons/md";
import OutboxIcon from "@mui/icons-material/Outbox";
import MoreVertIcon from "@mui/icons-material/MoreVert"; // Import MoreVertIcon
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../redux/selector";
import FaceIcon from "@mui/icons-material/Face";
import { green } from "@mui/material/colors"; // Import green color
import {
  addOrEditRecruiterAction,
  assignCandidateToRecruiterAction,
  getMyRecruitersAction,
  selectedRecruiterAction,
  updateAdminAccessAction,
  updateRecruiterStatusAction,
  resetCandidatesAction,
  getActiveCandidatesAction,
  removeAssignedCandidateAction,
  recruitersActivity,
  getAssignedCandidatesAction,
} from "../../redux/action";
import { userSelector } from "../../user-redux/selector";
import { Outbox, OutboxOutlined } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close"; //
import { RiUserShared2Line } from "react-icons/ri";
import moment from "moment/moment";
import DeleteIcon from "@mui/icons-material/Delete";

const getBackgroundColor = (index) => {
  const colors = [
    "rgb(234 193 184)",
    "rgb(162 195 168)",
    "rgb(144 154 202)",
    "rgb(121 154 202)",
    "rgb(104 174 202)",
  ];
  return colors[index % colors.length];
};

const AdminRecruiters = ({ searchTerm, onSearchChange }) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState(searchTerm); // State for search input
  const {
    myRecruiters,
    selectedRecruiter,
    activeCandidates,
    assignedCandidates,
  } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const [activeRecruiter, setActiveRecruiter] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [recruiterFormData, setRecruiterFormData] = useState({});
  const [openRecruiterDialog, setOpenRecruiterDialog] = useState(false);
  const [addRecruiterLoading, setRecruiterLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [allocatedRecruiter, setAllocatedRecruiter] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [recruiterToDelete, setRecruiterToDelete] = useState(null);

  const theme = useTheme();
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));

  const getRecruiterFormData = (recruiter) => ({
    company_admin_id: user?.id,
    recruiter_name: recruiter?.recruiter_name,
    recruiter_role: recruiter?.role,
    recruiter_phone: recruiter?.phone,
    recruiter_linkedin: recruiter?.linkedin,
    recruiter_email: recruiter?.recruiter_email,
    recruiter_password: "",
    recruiter_company_id: user?.companyid,
    status: 1,
    usertypeid: 3,
    action: "Edit",
    recruiter_id: recruiter?.recruiter_id,
    session_token: user.session_token,
    register_type: "CSR",
  });

  useEffect(() => {
    if (selectedRecruiter) {
      setRecruiterFormData(getRecruiterFormData(selectedRecruiter));
    }
  }, [selectedRecruiter]);


  const handleRecruiterSubmit = async () => {
    setRecruiterLoading(true);

    let rec_data = {
      company_id: user?.companyid,
    };

    const response = await dispatch(
      addOrEditRecruiterAction(recruiterFormData, rec_data)
    );

    // If the recruiter was successfully added
    if (response?.data?.insertId) {
      // Get the newly added recruiter's data
      const newRecruiter = {
        recruiter_id: response.data.insertId,
        recruiter_name: recruiterFormData.recruiter_name,
        recruiter_email: recruiterFormData.recruiter_email,
        role: recruiterFormData.recruiter_role,
        phone: recruiterFormData.recruiter_phone,
        linkedin: recruiterFormData.recruiter_linkedin,
        user_type_id: recruiterFormData.usertypeid,
        // Add other necessary fields
      };

      // Dispatch action to select the new recruiter
      dispatch(selectedRecruiterAction(newRecruiter));
    }

    setRecruiterLoading(false);
    setOpenRecruiterDialog(false);
  };

  const handleRecruiterChange = (e) => {
    const { name, value } = e.target;
    setRecruiterFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleSubmit = async () => {
    if (selectedCandidates?.length > 0) {
      const userId =
        user?.usertype == 13
          ? (user?.admin_id && user?.admin_id.trim() ? user?.admin_id : user?.id)
          : user?.id;

      const allocatedCandidatesData = {
        candidate_ids: selectedCandidates,
        user_id: userId,
        recruiter_id: selectedRecruiter?.recruiter_id,
      };
      await dispatch(
        assignCandidateToRecruiterAction(
          allocatedCandidatesData,
          userId,
          selectedRecruiter?.recruiter_id
        )
      );
      setOpenDialog(false); // Close dialog after successful submit
      // Optionally show a success toast here if you want for assignment
      // handleOpenSnackbar("Candidates assigned successfully", "success");
    } else {
      setOpenDialog(false); // Just close the dialog, do NOT show snackbar
      // Do NOT call setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    if (selectedRecruiter) {
      setActiveRecruiter(selectedRecruiter);
    }
  }, [selectedRecruiter]);

  // Also update the initial mounting effect to respect selectedRecruiter if it exists
  useEffect(() => {
    if (selectedRecruiter) {
      setActiveRecruiter(selectedRecruiter);
    } else if (myRecruiters?.length > 0) {
      setActiveRecruiter(myRecruiters[0]);
    }
  }, [myRecruiters]);

  //console.log("myRecruiters",myRecruiters);
  const filteredRecruiters = myRecruiters?.filter((recruiter) =>
    recruiter?.recruiter_name
      ?.toLowerCase()
      .startsWith(searchTerm.toLowerCase())
  );

  // When search changes, auto-select the first filtered recruiter.
  // If no recruiters match, clear selection so candidates/submissions go empty.
  useEffect(() => {
    if (!searchTerm) return; // No search active — leave existing selection alone

    if (filteredRecruiters?.length > 0) {
      const first = filteredRecruiters[0];
      setActiveRecruiter(first);
      dispatch(selectedRecruiterAction(first));
    } else {
      // No match — clear everything
      setActiveRecruiter(null);
      dispatch(selectedRecruiterAction(null));
    }
  }, [searchTerm]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = (recruiter) => {
    if (recruiter && recruiter.recruiter_id) {
      setActiveRecruiter(recruiter);
      dispatch(selectedRecruiterAction(recruiter));
      // getAssignedCandidatesAction is already called inside selectedRecruiterAction
    }
  };

  const handleMoreClick = (event, recruiter) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedRecruiter(null);
  };

  const handleMenuItemClick = async (action) => {
    if (action === "Access to Admin") {
      const recruiterData = {
        user_id: selectedRecruiter?.recruiter_id,
        user_type: 13,
      };
      const response = await dispatch(updateAdminAccessAction(recruiterData));
      if (response?.data?.affectedRows > 0) {
        handleOpenSnackbar("Added Admin Access", "success");
        let rec_data = {
          company_id: user?.companyid,
        };
        dispatch(getMyRecruitersAction(rec_data));
      }
    } else if (action === "Remove Admin Access") {
      const recruiterData = {
        user_id: selectedRecruiter?.recruiter_id,
        user_type: 3,
      };
      const response = await dispatch(updateAdminAccessAction(recruiterData));
      if (response?.data?.affectedRows > 0) {
        handleOpenSnackbar("Removed Admin Access", "error");
        let rec_data = {
          company_id: user?.companyid,
        };
        dispatch(getMyRecruitersAction(rec_data));
      }
    }
    handleMenuClose();
  };

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleEditRecruiter = () => {
    if (selectedRecruiter) {
      setRecruiterFormData(getRecruiterFormData(selectedRecruiter));
    }
    setOpenRecruiterDialog(true);
  };

  const handleRecruiterDialogClose = () => {
    setOpenRecruiterDialog(false);
  };

  const handleUpdateStatus = () => {
    const updatedData = {
      status: 0,
      recruiter_ids: [selectedRecruiter.recruiter_id],
    };

    let rec_data = {
      company_id: user?.companyid,
    };
    dispatch(updateRecruiterStatusAction(updatedData, rec_data, "active"));
  };

  const handleDeleteRecruiter = (recruiter) => {
    setRecruiterToDelete(recruiter);
    setShowDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setShowDeleteDialog(false);
    setRecruiterToDelete(null);
  };

  const handleDeleteConfirm = async () => {
    if (!recruiterToDelete) return;
    try {
      const response = await fetch(
        `${Key.domain}/user/recruiter/${recruiterToDelete.recruiter_uid}`,
        { method: "DELETE" }
      );
      handleDeleteDialogClose();
      if (response.ok) {
        handleOpenSnackbar("Recruiter deleted successfully", "success");
        setTimeout(() => {
          dispatch(getMyRecruitersAction({ company_id: user?.companyid }));
        }, 800);
      } else {
        handleOpenSnackbar("Failed to delete recruiter", "error");
      }
    } catch (error) {
      handleDeleteDialogClose();
      handleOpenSnackbar("Error deleting recruiter", "error");
    }
  };

  const handleDialogOpen = async () => {
    setLoading(true);
    setAllocatedRecruiter("");
    setSelectedCandidates([]);
    setOpenDialog(true);

    await dispatch(resetCandidatesAction());
    setLoading(true);
    await dispatch(getActiveCandidatesAction(user?.id, 1, 200));
    setLoading(false);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  // Set the first recruiter as default on component mount (only on initial load)
  useEffect(() => {
    if (myRecruiters?.length > 0 && !selectedRecruiter) {
      const firstRecruiter = myRecruiters[0];
      setActiveRecruiter(firstRecruiter);
      dispatch(selectedRecruiterAction(firstRecruiter));

      // Fetch assigned candidates for the first recruiter
      const recruiterData = {
        recruiter_id: firstRecruiter.recruiter_id,
        company_admin_id: user?.id
      };
      dispatch(getAssignedCandidatesAction(recruiterData));
    }
  }, [myRecruiters]); // Removed selectedRecruiter dependency to prevent circular calls

  const assignedCandidateIds = assignedCandidates?.map(
    (candidate) => candidate.candidate_id
  );
  const unassignedCandidates = activeCandidates?.filter(
    (candidate) => !assignedCandidateIds.includes(candidate.candidate_id)
  );

  const filteredCandidates = unassignedCandidates?.filter((candidate) =>
    candidate.candidate_name.toLowerCase().startsWith(searchValue.toLowerCase())
  );

  const dialogHeight = filteredCandidates.length <= 10 ? "700px" : "700px"; // Example heights
  const handleRemoveCandidate = (candidateId) => {
    const candidateData = {
      candidate_id: candidateId,
      recruiter_id: selectedRecruiter?.recruiter_id,
    };
    const assignedData = {
      recruiter_id: selectedRecruiter?.recruiter_id,
    };
    dispatch(removeAssignedCandidateAction(candidateData, assignedData));
    handleOpenSnackbar("Candidate Removed Successfully", "success");
  };
  const hoverIconStyles = {
    height: isDesktopLarge ? "20px" : isDesktopSmall ? "16px" : "13px",
    width: isDesktopLarge ? "20px" : isDesktopSmall ? "16px" : "13px",
    color: "#616161",
    "&:hover": {
      bgcolor: "#F5F5F5",
      color: "#424242",
    },
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <Box>
          <List>
            {filteredRecruiters?.length > 0 ? (
              filteredRecruiters.map((recruiter, index) => (
                <ListItemButton
                  key={index}
                  selected={
                    recruiter?.recruiter_id === activeRecruiter?.recruiter_id
                  }
                  onMouseEnter={() => setHoveredIndex(index)} // Set hovered index on mouse enter
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => handleClick(recruiter)}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <Box
                        sx={{
                          position: "relative", // For the status dot placement
                          display: "inline-block",
                        }}
                      >
                        {/* Tooltip with Compact Card Content */}

                        <Tooltip
                          sx={{ backgroundClip: "none" }}
                          placement="bottom"
                          disableInteractive
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                p: 0,
                                m: 0,
                                overflow: "visible",
                                transition: 'opacity 0.3s',
                              },
                            },
                          }}
                          title={
                            <Box
                              sx={{
                                position: 'relative',
                                background: 'rgba(255,255,255,0.92)',
                                boxShadow: '0 4px 16px rgba(60,72,100,0.13)',
                                borderRadius: '14px',
                                p: 1.5,
                                minWidth: '230px',
                                maxWidth: '270px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                border: '1px solid #e3e8ee',
                                overflow: 'hidden',
                                backdropFilter: 'blur(4px)',
                                animation: 'fadeIn 0.2s',
                                '@keyframes fadeIn': {
                                  from: { opacity: 0 },
                                  to: { opacity: 1 },
                                },
                              }}
                            >
                              {/* Vertical Accent Bar */}
                              <Box sx={{
                                position: 'absolute',
                                left: 0,
                                top: 0,
                                height: '100%',
                                width: '4px',
                                background: 'linear-gradient(180deg, #1976d2 0%, #64b5f6 100%)',
                                borderTopLeftRadius: '14px',
                                borderBottomLeftRadius: '14px',
                              }} />
                              {/* Recruiter Name & Avatar */}
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, width: '100%' }}>
                                <Avatar
                                  user={user}
                                  handleOpenUserMenu={handleOpenUserMenu}
                                  src={recruiter?.image ? `${Key.aws_bucket_profile}/attachments/user_${recruiter?.recruiter_uid}/profileimages/${recruiter?.image}` : ""}
                                  sx={{
                                    backgroundColor: '#1976d2',
                                    textTransform: 'capitalize',
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    width: 36,
                                    height: 36,
                                    border: '1.5px solid #e3e8ee',
                                    boxShadow: '0 1px 4px rgba(25, 118, 210, 0.08)',
                                  }}
                                >
                                  {recruiter?.recruiter_name?.[0]}
                                </Avatar>
                                <Box sx={{ ml: 1.2 }}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#222', fontSize: '14px', mb: 0.2 }}>
                                    {recruiter.recruiter_name || 'N/A'}
                                  </Typography>
                                  <Typography variant="caption" sx={{ color: '#6b7280', fontSize: '12px' }}>
                                    {recruiter.role || 'Admin'}
                                  </Typography>
                                </Box>
                              </Box>
                              <Divider sx={{ width: '100%', my: 0.7, borderColor: '#e3e8ee' }} />
                              {/* Contact Section */}
                              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 0.5 }}>
                                <EmailIcon sx={{ color: '#1976d2', fontSize: 15, mr: 0.7 }} />
                                <Typography variant="caption" sx={{ color: '#444', fontSize: '12px', wordBreak: 'break-all' }}>
                                  {recruiter?.recruiter_email || 'N/A'}
                                </Typography>
                              </Box>
                              <Divider sx={{ width: '100%', my: 0.5, borderColor: '#f0f0f0' }} />
                              {recruiter.phone && recruiter.phone !== 'null' && <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 0.5 }}>
                                <PhoneIcon sx={{ color: '#4caf50', fontSize: 15, mr: 0.7 }} />
                                <Typography variant="caption" sx={{ color: '#444', fontSize: '12px' }}>
                                  {recruiter.phone}
                                </Typography>
                              </Box>}
                              <Divider sx={{ width: '100%', my: 0.5, borderColor: '#f0f0f0' }} />
                              {recruiter.linkedin && recruiter.linkedin !== 'null' && <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <LinkedInIcon sx={{ color: '#0077b5', fontSize: 15, mr: 0.7 }} />
                                {recruiter.linkedin && recruiter.linkedin !== 'null' ? (
                                  <a
                                    href={recruiter.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      color: '#1976d2',
                                      fontWeight: 600,
                                      fontSize: '12px',
                                      textDecoration: 'underline',
                                      marginLeft: 2,
                                      transition: 'color 0.2s',
                                      display: 'inline-block',
                                    }}
                                  >
                                    LinkedIn
                                  </a>
                                ) : (
                                  <Typography variant="caption" sx={{ color: '#444', fontSize: '12px' }}>
                                    {recruiter.linkedin}
                                  </Typography>
                                )}
                              </Box>}
                            </Box>
                          }
                        >
                          <Box
                            sx={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            {/* Avatar */}
                            <Avatar
                              alt={recruiter?.recruiter_name || "Recruiter"}
                              user={user}
                              handleOpenUserMenu={handleOpenUserMenu}
                              src={recruiter?.image ? `${Key.aws_bucket_profile}/attachments/user_${recruiter?.recruiter_uid}/profileimages/${recruiter?.image}` : ""}
                              style={{
                                backgroundColor: getBackgroundColor(index),
                                textTransform: "capitalize",
                                fontSize: "12px",
                                cursor: "pointer", // Make it interactive
                                width: 40,
                                height: 40, // Slightly larger avatar size for visibility
                              }}
                            />
                          </Box>
                        </Tooltip>
                      </Box>

                      <Box>
                        <Typography
                          variant="body1"
                          style={{ fontSize: "12px", fontWeight: 600 }}
                        >
                          {recruiter.recruiter_name}
                          {/* {recruiter?.activity?.is_active} */}
                        </Typography>

                        {recruiter.user_type_id === "13" ? (
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "11px",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                              padding: "2px 6px",
                              border: "1px solid green",
                              borderRadius: "12px",
                            }}
                          >
                            <span
                              style={{
                                width: 6,
                                height: 6,
                                backgroundColor: "green",
                                borderRadius: "50%",
                                display: "inline-block",
                              }}
                            ></span>
                            Admin
                          </Typography>
                        ) : (
                          <Typography
                            variant="body2"
                            style={{ fontSize: "11px" }}
                          >
                            {recruiter.role}
                          </Typography>
                        )}
                      </Box>

                    </Box>

                    {/* Conditionally render the Admin Chip */}
                    {recruiter?.user_type_id == 13 && user?.usertype == 7 && (
                      <FormControlLabel
                        control={
                          <Radio
                            checked
                            size="12px"
                            sx={{
                              color: green[500],
                              "&.Mui-checked": {
                                color: green[500],
                              },
                              fontSize: "12px",
                              marginLeft: "12px",
                            }}
                            disabled
                          />
                        }
                        label={
                          <Typography
                            variant="body2"
                            style={{
                              color: green[500],
                              fontWeight: 500,
                              marginLeft: -5,
                            }}
                          >
                            Admin
                          </Typography>
                        }
                      />
                    )}

                    {/* Icon Buttons with Tooltip and MoreVertIcon side by side */}
                    <Box display="flex" alignItems="center">
                      {hoveredIndex === index && recruiter.user_type_id === "3" && (
                        <>
                          <Tooltip followCursor title="Allocation">
                            <IconButton>
                              <RiUserShared2Line
                                size="14"
                                onClick={handleDialogOpen}
                              />
                            </IconButton>
                          </Tooltip>
                          <IconButton size="small" edge="end">
                            <MdMoreVert
                              onClick={(event) =>
                                handleMoreClick(event, recruiter)
                              }
                            />
                          </IconButton>

                          <Menu
                            anchorEl={
                              anchorEl && document.body.contains(anchorEl)
                                ? anchorEl
                                : null
                            }
                            open={Boolean(
                              anchorEl && document.body.contains(anchorEl)
                            )}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                          >
                            {/* Conditional Menu Item */}
                            {selectedRecruiter?.user_type_id == 13 &&
                              user?.usertype == 7 && (
                                <MenuItem
                                  style={{ fontSize: "14px" }}
                                  onClick={() =>
                                    handleMenuItemClick("Remove Admin Access")
                                  }
                                >
                                  Remove Admin Access
                                </MenuItem>
                              )}

                            <MenuItem
                              style={{ fontSize: "14px" }}
                              onClick={() => handleEditRecruiter()}
                            >
                              Edit
                            </MenuItem>
                            <MenuItem
                              style={{ fontSize: "14px" }}
                              onClick={() => handleUpdateStatus()}
                            >
                              Inactive
                            </MenuItem>
                            <MenuItem
                              style={{ fontSize: "14px" }}
                              onClick={() => handleDeleteRecruiter(recruiter)}
                            >
                              Delete
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    </Box>
                  </Box>
                </ListItemButton>
              ))
            ) : (
              <Typography variant="body1" style={{ padding: "16px" }}>
                No recruiters found
              </Typography>
            )}
          </List>
        </Box>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ zIndex: 2000 }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <Dialog open={openRecruiterDialog} onClose={handleRecruiterDialogClose}>
          <DialogTitle>Edit Recruiter</DialogTitle>
          <Divider />
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  autoFocus
                  margin="dense"
                  label="Name"
                  name="recruiter_name"
                  fullWidth
                  variant="outlined"
                  value={recruiterFormData.recruiter_name}
                  onChange={handleRecruiterChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Email"
                  name="recruiter_email"
                  disabled
                  fullWidth
                  variant="outlined"
                  value={recruiterFormData.recruiter_email}
                  onChange={handleRecruiterChange}
                />
              </Grid>
              <Grid item xs={6}>
                <InputMask
                  mask="(999) 999-9999"
                  value={recruiterFormData.recruiter_phone}
                  onChange={handleRecruiterChange}
                >
                  {() => (
                    <TextField
                      margin="dense"
                      label="Mobile"
                      name="recruiter_phone"
                      fullWidth
                      variant="outlined"
                    // value={recruiterFormData.recruiter_phone}
                    // onChange={handleRecruiterChange}
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Role"
                  name="recruiter_role"
                  fullWidth
                  variant="outlined"
                  value={recruiterFormData.recruiter_role}
                  onChange={handleRecruiterChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Linkedin url"
                  name="recruiter_linkedin"
                  fullWidth
                  variant="outlined"
                  value={recruiterFormData.recruiter_linkedin}
                  onChange={handleRecruiterChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="CompanyName"
                  name="companyName"
                  disabled
                  fullWidth
                  variant="outlined"
                  value={user?.companyname}
                  onChange={handleRecruiterChange}
                // disabled
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleRecruiterDialogClose} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleRecruiterSubmit}
              variant="contained"
              disabled={addRecruiterLoading ? true : false}
            >
              {addRecruiterLoading ? "Submitting" : "Submit"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openDialog}
          onClose={handleDialogClose}
          fullWidth
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "12px",
              padding: "20px",
            },
            height: dialogHeight,
          }}
        >
          <DialogTitle
            sx={{
              textAlign: "left",
              fontWeight: "bold",
              color: "#406882",
              padding: "0px",
              marginTop: "10px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  label="Search Candidate Name"
                  variant="outlined"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  sx={{
                    borderRadius: "5px",
                    fontSize: "15px",
                    padding: "5px",
                  }}
                  InputProps={{
                    endAdornment: searchValue && (
                      <InputAdornment position="end">
                        <Tooltip title="Clear">
                          <IconButton
                            onClick={() => setSearchValue("")}
                            edge="end"
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent style={{ padding: "0" }}>
            <Box component="form" noValidate autoComplete="off" sx={{}}>
              {loading ? (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  mt={2}
                  p={5}
                >
                  <Alert
                    severity="info"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Box p={1}>
                      <AlertTitle>Fetching Active Candidates</AlertTitle>
                      We are fetching the Candidates. Please wait.......
                    </Box>
                    <LinearProgress style={{ width: "100%" }} />
                  </Alert>
                </Box>
              ) : (
                <>
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: "500", my: "5px" }}
                    >
                      {assignedCandidates?.length > 0 ? "Assigned Candidates" : "Add candidates from the below list"}
                    </Typography>
                    {assignedCandidates?.length > 0 && (
                      <Box>
                        {assignedCandidates
                          .filter(
                            (candidate) =>
                              candidate.status === 1
                          )
                          .map((candidate, index) => (
                            <Chip
                              key={index}
                              label={candidate.candidate_name}
                              sx={{ margin: "4px", backgroundColor: "aliceblue" }}
                              icon={<CloseIcon style={{ fontSize: "15px" }}
                                onClick={() =>
                                  handleRemoveCandidate(candidate?.candidate_id)
                                } />}
                            />
                          ))}
                      </Box>
                    )}
                  </Box>
                  <Box>
                    {filteredCandidates?.length > 0 ? (
                      filteredCandidates.map((candidate, value) => (
                        <Box
                          key={value}
                          sx={{
                            mb: 0,
                            display: "flex",
                            flexDirection: "column",
                            padding: "5px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 0,
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={selectedCandidates?.includes(
                                    candidate.candidate_id
                                  )}
                                  onChange={() => {
                                    setSelectedCandidates(
                                      selectedCandidates.includes(
                                        candidate.candidate_id
                                      )
                                        ? selectedCandidates.filter(
                                          (id) =>
                                            id !== candidate.candidate_id
                                        )
                                        : [
                                          ...selectedCandidates,
                                          candidate.candidate_id,
                                        ]
                                    );
                                  }}
                                  value={candidate.candidate_id}
                                  color="primary"
                                  sx={{ fontSize: "12px" }}
                                />
                              }
                            />
                            <Box sx={{ padding: "0" }}>
                              <Typography variant="body1" color="textprimary">
                                {candidate.candidate_name}
                              </Typography>
                              <Typography
                                variant="body"
                                color="textSecondary"
                                style={{ fontSize: "12px" }}
                              >
                                {candidate.role}
                              </Typography>
                            </Box>
                          </Box>
                          <Divider style={{ color: "lightgray" }} />
                        </Box>
                      ))
                    ) : (
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mt={2}
                        p={5}
                      >
                        <Typography variant="body1" sx={{ fontWeight: "500", my: "5px" }}>
                          {searchValue ? "No candidates match your search" : "No candidates found"}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} variant="outlined">
              Cancel
            </Button>
            <Button onClick={handleSubmit} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={showDeleteDialog}
          onClose={handleDeleteDialogClose}
          aria-labelledby="delete-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '12px',
              padding: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          <DialogTitle
            id="delete-dialog-title"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              //color: '#d32f2f',
              fontWeight: 600,
              fontSize: '1.25rem',
              padding: '16px 24px'
            }}
          >
            <DeleteIcon color="error" />
            Delete Recruiter
          </DialogTitle>
          <Divider />
          <DialogContent sx={{ padding: '24px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography variant="body1" sx={{ color: '#333', fontSize: '1rem' }}>
                Are you sure you want to delete <strong>{recruiterToDelete?.recruiter_name || 'this recruiter'}</strong>?
              </Typography>
              <Alert severity="warning" sx={{
                backgroundColor: '#fff3e0',
                '& .MuiAlert-icon': {
                  color: '#ed6c02'
                }
              }}>
                All candidate assigned to this recruiter will be unassigned.
              </Alert>
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ padding: '16px 24px', gap: 1 }}>
            <Button
              onClick={handleDeleteDialogClose}
              variant="outlined"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                padding: '8px 24px',
                borderColor: '#e0e0e0',
                '&:hover': {
                  borderColor: '#bdbdbd',
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteConfirm}
              variant="contained"
              color="error"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                padding: '8px 24px',
                backgroundColor: '#d32f2f',
                '&:hover': {
                  backgroundColor: '#b71c1c'
                }
              }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default AdminRecruiters;